/**
 * User Roles Constants
 * 
 * This file defines all available user roles in the system.
 */

export const USER_ROLES = {
  ADMIN: 'admin',
  BLOGGER: 'blogger',
  CENTER_ADMIN: 'center_admin',
};

/**
 * Array of all roles
 */
export const ALL_ROLES = Object.values(USER_ROLES);

/**
 * Role display names
 */
export const ROLE_DISPLAY_NAMES = {
  [USER_ROLES.ADMIN]: 'Admin',
  [USER_ROLES.BLOGGER]: 'Blogger',
  [USER_ROLES.CENTER_ADMIN]: 'Center Admin',
};

/**
 * Role hierarchy (higher number = more permissions)
 */
export const ROLE_HIERARCHY = {
  [USER_ROLES.ADMIN]: 3,
  [USER_ROLES.CENTER_ADMIN]: 2,
  [USER_ROLES.BLOGGER]: 1,
};

/**
 * Check if a role has permission to perform an action
 * @param {string} userRole - The user's role
 * @param {string} requiredRole - The minimum role required
 * @returns {boolean} - True if user has sufficient permissions
 */
export const hasRolePermission = (userRole, requiredRole) => {
  const userLevel = ROLE_HIERARCHY[userRole] || 0;
  const requiredLevel = ROLE_HIERARCHY[requiredRole] || 0;
  return userLevel >= requiredLevel;
};

/**
 * Get role display name
 * @param {string} role - The role key
 * @returns {string} - Display name for the role
 */
export const getRoleDisplayName = (role) => {
  return ROLE_DISPLAY_NAMES[role] || role;
};

/**
 * Check if role is valid
 * @param {string} role - The role to check
 * @returns {boolean} - True if role is valid
 */
export const isValidRole = (role) => {
  return ALL_ROLES.includes(role);
};

export default USER_ROLES;

